import { baseUrl } from "../../../../lib/routes/baseUrl";
import buildUrl from "../../../../lib/utils/buildUrl";
import { ITypesCharacteristicsListSearch } from "../../types/TypesCharacteristicsListSearch";
import { IDeleteValuesTypesCharacteristicsParams } from "../../types/DeleteValuesTypesCharacteristicsParams";
import { IDeleteTypesCharacteristicsParams } from "../../types/DeleteTypesCharacteristicsParams";
import { ITypesCharacteristicsObjectListSearch } from "../../types/TypesCharacteristicsObjectListSearch";
import { IUpdateTypesCharacteristicsParams } from "../../types/UpdateTypesCharacteristicsParams";

export const getTypesCharacteristicsObjectObjectTypesDicRoute = () => {
  return buildUrl({ url: `${baseUrl}/dict-api/object-types` });
};

export const searchTypesCharacteristicsRoute = (searchParams: ITypesCharacteristicsListSearch) => {
  return buildUrl({
    url: [baseUrl, "dict-api", "char-types", "pageable-search"].join("/"),
    searchParams: { ...searchParams, sort: "id" },
  });
};

export const searchTypesCharacteristicsObjectRoute = (
  searchParams: ITypesCharacteristicsObjectListSearch
) => {
  return buildUrl({
    url: [baseUrl, "dict-api", "object-char-types", "search"].join("/"),
    searchParams: { ...searchParams },
  });
};

// ------

export const createTypesCharacteristicsObjectRoute = (objectTypeId: number) => {
  return buildUrl({
    url: [baseUrl, "dict-api", "object-char-types", objectTypeId].join("/"),
  });
};

export const searchTypesCharacteristicsByIdRoute = (charTypeId: string) => {
  return buildUrl({
    url: [baseUrl, "dict-api", "char-types", charTypeId].join("/"),
  });
};

export const searchTypesCharacteristicsObjectByIdRoute = (
  objectTypeId: string,
  objectCharTypeId: string,
  onDate?: string
) => {
  return buildUrl({
    url: [baseUrl, "dict-api", "object-char-types", objectTypeId, objectCharTypeId].join("/"),
    searchParams: {
      includePastDatesValues: false,
      includeFutureDatesValues: true,
      onDate,
    },
  });
};

export const getTypesCharacteristicsDicRoute = (dictType: string) => {
  return buildUrl({ url: `${baseUrl}/dict-api/dictionaries/${dictType}` });
};

export const getTypesCharacteristicsDictionaryTypesRoute = () => {
  return buildUrl({ url: `${baseUrl}/dict-api/dictionary-types` });
};

export const deleteValuesTypesCharacteristicsObjectRoute = (
  deleteParams: IDeleteValuesTypesCharacteristicsParams
) => {
  return buildUrl({
    url: [baseUrl, "dict-api", "object-char-types-values"].join("/"),
    searchParams: { ...deleteParams },
  });
};

export const addValuesTypesCharacteristicsObjectRoute = (objectCharTypeId: number) => {
  return buildUrl({
    url: [baseUrl, "dict-api", "object-char-types-values", objectCharTypeId].join("/"),
  });
};

export const deleteTypesCharacteristicsObjectRoute = (
  deleteParams: IDeleteTypesCharacteristicsParams
) => {
  return buildUrl({
    url: [
      baseUrl,
      "dict-api",
      "object-char-types",
      deleteParams.objectTypeId,
      deleteParams.objectCharTypeId,
    ].join("/"),
    searchParams: { onDate: deleteParams.onDate },
  });
};

export const updateTypesCharacteristicsObjectRoute = (
  updateParams: IUpdateTypesCharacteristicsParams["query"]
) => {
  return buildUrl({
    url: [
      baseUrl,
      "dict-api",
      "object-char-types",
      updateParams.objectTypeId,
      updateParams.objectCharTypeId,
    ].join("/"),
    searchParams: { onDate: updateParams.onDate, force: updateParams.force },
  });
};
